import * as React from "react"

import { cn } from "@/lib/utils"

function Card({
  className,
  size = "default",
  variant = "glass",
  ...props
}: React.ComponentProps<"div"> & {
  size?: "default" | "sm"
  variant?: "glass" | "bento" | "solid" | "brand" | "product"
}) {
  return (
    <div
      data-slot="card"
      data-size={size}
      data-variant={variant}
      className={cn(
        "group/card flex flex-col gap-(--card-spacing) overflow-hidden rounded-[var(--scaena-radius-surface)] border border-[var(--scaena-glass-border)] py-(--card-spacing) font-ui text-sm text-card-foreground backdrop-blur-none md:backdrop-blur-[40px] [--card-spacing:--spacing(6)] has-[>img:first-child]:pt-0 data-[size=sm]:[--card-spacing:--spacing(4)] data-[variant=glass]:bg-[var(--scaena-glass)] data-[variant=glass]:[box-shadow:var(--scaena-shadow-glass)] data-[variant=bento]:bg-[var(--scaena-glass)] data-[variant=bento]:[box-shadow:var(--scaena-shadow-bento)] data-[variant=solid]:border-border data-[variant=solid]:bg-white data-[variant=solid]:backdrop-blur-none data-[variant=solid]:[box-shadow:var(--scaena-shadow-solid)] data-[variant=brand]:border-0 data-[variant=brand]:bg-[linear-gradient(180deg,rgba(255,255,255,0.15)_0%,rgba(255,255,255,0)_100%)] data-[variant=brand]:bg-primary data-[variant=brand]:text-primary-foreground data-[variant=brand]:backdrop-blur-none data-[variant=brand]:[box-shadow:var(--scaena-shadow-primary)] data-[variant=product]:gap-3 data-[variant=product]:rounded-none data-[variant=product]:border-0 data-[variant=product]:bg-transparent data-[variant=product]:py-5 data-[variant=product]:backdrop-blur-none data-[variant=product]:[--card-spacing:--spacing(4)] data-[variant=product]:[box-shadow:none] *:[img:first-child]:rounded-t-[var(--scaena-radius-surface)] *:[img:last-child]:rounded-b-[var(--scaena-radius-surface)]",
        className
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        "group/card-header @container/card-header grid auto-rows-min items-start gap-1.5 rounded-t-[var(--scaena-radius-surface)] px-(--card-spacing) has-data-[slot=card-action]:grid-cols-[1fr_auto] has-data-[slot=card-description]:grid-rows-[auto_auto] [.border-b]:pb-(--card-spacing)",
        className
      )}
      {...props}
    />
  )
}

function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-title"
      className={cn("font-heading text-lg font-[650] tracking-[-0.02em] group-data-[variant=product]/card:text-sm group-data-[variant=product]/card:font-[550]", className)}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-description"
      className={cn("text-sm text-muted-foreground", className)}
      {...props}
    />
  )
}

function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-action"
      className={cn(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        className
      )}
      {...props}
    />
  )
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("px-(--card-spacing)", className)}
      {...props}
    />
  )
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn(
        "flex items-center rounded-b-[var(--scaena-radius-surface)] px-(--card-spacing) [.border-t]:pt-(--card-spacing)",
        className
      )}
      {...props}
    />
  )
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
}
